/**
 * A re-entry guard for a handler that must not run twice at once (Enter in the buyer sheet, a double click on
 * Pay): `enter()` is false while a run is in flight, `leave()` ends it (CIN-15436). Plain TypeScript, so
 * `node --test` can run it.
 */
export function createSingleFlight() {
    let busy = false;
    return {
        get busy(): boolean {
            return busy;
        },
        enter(): boolean {
            if (busy) return false;
            busy = true;
            return true;
        },
        leave(): void {
            busy = false;
        }
    };
}
